import { OperationFailures } from "../../../../../../shared/frontend/operations/OperationFailures";
import { useI18n } from "../i18n/useI18n";
import { useFinanceOperations } from "./useFinanceOperation";

export function FinanceOperationErrors() {
  const { store, entries } = useFinanceOperations();
  const { text } = useI18n();
  return <OperationFailures entries={entries} retry={store.retry} errorLabel={text("Error loading data")} retryLabel={text("Retry")} />;
}
